// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1ia0o","footer":"ReportModalFilter_footer__3Frld"};